export default __webpack_public_path__ + "static/media/icon-gold.ac186964.svg";